import { APP_ROUTE } from '@backrs_ui/grow-ui/src/App';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { SOLUTION_SESSION_IDS } from '@backrs_ui/grow-ui/src/models/models';

import { ActionStickerCardSection, HomePageSection } from './useGetHomePageSections';

const ATTAIN_FINANCIAL_FREEDOM_STRINGS =
  appStrings.modules.home.sections.personalHealthAndWellness.attainFinancialFreedom;
const BE_WELL_STRINGS = appStrings.modules.home.sections.personalHealthAndWellness.beWell;
const MASTER_MINDSETS_STRINGS =
  appStrings.modules.home.sections.personalHealthAndWellness.masterMindsets;

export const ATTAIN_FINANCIAL_FREEDOM_SECTION = ({
  navigate,
  getCompetencyUrl,
}: HomePageSection): ActionStickerCardSection => ({
  title: ATTAIN_FINANCIAL_FREEDOM_STRINGS.title,
  description: ATTAIN_FINANCIAL_FREEDOM_STRINGS.description,
  actionStickerCards: [
    {
      title: ATTAIN_FINANCIAL_FREEDOM_STRINGS.actionStickerCards.extraCash.title,
      description: ATTAIN_FINANCIAL_FREEDOM_STRINGS.actionStickerCards.extraCash.description,
      stickerUrl: '/images/stickers/Money.png',
      onClick: () => navigate(getCompetencyUrl('Securing extra Cash')),
    },
    {
      title: ATTAIN_FINANCIAL_FREEDOM_STRINGS.actionStickerCards.lowerTheCostOfCollege.title,
      description:
        ATTAIN_FINANCIAL_FREEDOM_STRINGS.actionStickerCards.lowerTheCostOfCollege.description,
      stickerUrl: '/images/stickers/PriceTag.png',
      onClick: () =>
        navigate(
          APP_ROUTE.SOLUTION_SESSION.replace(':id?', SOLUTION_SESSION_IDS.LOWER_COST_OF_COLLEGE),
        ),
    },
    {
      title: ATTAIN_FINANCIAL_FREEDOM_STRINGS.actionStickerCards.buildCredit.title,
      description: ATTAIN_FINANCIAL_FREEDOM_STRINGS.actionStickerCards.buildCredit.description,
      stickerUrl: '/images/stickers/Receipt.png',
      onClick: () => navigate(getCompetencyUrl('Credit / Debt')),
    },
    {
      title: ATTAIN_FINANCIAL_FREEDOM_STRINGS.actionStickerCards.savingsAndInvesting.title,
      description:
        ATTAIN_FINANCIAL_FREEDOM_STRINGS.actionStickerCards.savingsAndInvesting.description,
      stickerUrl: '/images/stickers/DocumentFolder.png',
      onClick: () => navigate(getCompetencyUrl('Savings & investing')),
    },
  ],
});

export const BE_WELL_SECTION = ({
  navigate,
  getCompetencyUrl,
}: HomePageSection): ActionStickerCardSection => ({
  title: BE_WELL_STRINGS.title,
  description: BE_WELL_STRINGS.description,
  actionStickerCards: [
    {
      title: BE_WELL_STRINGS.actionStickerCards.navigatingStress.title,
      description: BE_WELL_STRINGS.actionStickerCards.navigatingStress.description,
      stickerUrl: '/images/stickers/StressThought.png',
      onClick: () => navigate(getCompetencyUrl('stress / anxiety')),
    },
    {
      title: BE_WELL_STRINGS.actionStickerCards.sleepRestoration.title,
      description: BE_WELL_STRINGS.actionStickerCards.sleepRestoration.description,
      stickerUrl: '/images/stickers/SleepCloud.png',
      onClick: () => navigate(getCompetencyUrl('Sleep / Restoration')),
    },
    {
      title: BE_WELL_STRINGS.actionStickerCards.familyDynamics.title,
      description: BE_WELL_STRINGS.actionStickerCards.familyDynamics.description,
      stickerUrl: '/images/stickers/Merchandise.png',
      onClick: () => navigate(getCompetencyUrl('Family Dynamics')),
    },
    {
      title: BE_WELL_STRINGS.actionStickerCards.healthcare.title,
      description: BE_WELL_STRINGS.actionStickerCards.healthcare.description,
      stickerUrl: '/images/stickers/Flag.png',
      onClick: () => navigate(getCompetencyUrl('Accessing Healthcare')),
    },
  ],
});

export const MASTER_MINDSETS_SECTION = ({
  navigate,
  getCompetencyUrl,
}: HomePageSection): ActionStickerCardSection => ({
  title: MASTER_MINDSETS_STRINGS.title,
  description: MASTER_MINDSETS_STRINGS.description,
  actionStickerCards: [
    {
      title: MASTER_MINDSETS_STRINGS.actionStickerCards.agency.title,
      description: MASTER_MINDSETS_STRINGS.actionStickerCards.agency.description,
      stickerUrl: '/images/stickers/DancingShoes.png',
      onClick: () => navigate(getCompetencyUrl('Agency')),
    },
    {
      title: MASTER_MINDSETS_STRINGS.actionStickerCards.learnToLearn.title,
      description: MASTER_MINDSETS_STRINGS.actionStickerCards.learnToLearn.description,
      stickerUrl: '/images/stickers/CraftsDIY.png',
      onClick: () => navigate(getCompetencyUrl('Learning')),
    },
    {
      title: MASTER_MINDSETS_STRINGS.actionStickerCards.growthMindset.title,
      description: MASTER_MINDSETS_STRINGS.actionStickerCards.growthMindset.description,
      stickerUrl: '/images/stickers/ThumbsUp.png',
      onClick: () => navigate(getCompetencyUrl('Growth Mindset')),
    },
    {
      title: MASTER_MINDSETS_STRINGS.actionStickerCards.problemSolve.title,
      description: MASTER_MINDSETS_STRINGS.actionStickerCards.problemSolve.description,
      stickerUrl: '/images/stickers/Calendar.png',
      onClick: () => navigate(getCompetencyUrl('Problem Solving')),
    },
  ],
});
